import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//element ui
import ElementUI from "element-ui";
Vue.use(ElementUI);

import { Tabs, Tab } from "vue-tabs-component";
import "vue-tabs-component/docs/resources/tabs-component.css";

Vue.component("tabs", Tabs);
Vue.component("tab", Tab);

import "./assets/tailwind.css";

import VueMobileDetection from "vue-mobile-detection";

Vue.use(VueMobileDetection);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
